import Vue from 'vue';
import emptyImg from '@/assets/images/noData.png';
import noCollect from '@/assets/images/noCollect.png';
import error from '@/assets/images/error.png';
import mdata from '@/assets/images/m-data.png';
import mcollect from '@/assets/images/m-collect.png';
import merror from '@/assets/images/m-error.png';
const toggle = (el, binding) => {
  Vue.nextTick(() => {
    let wrapInner = el.emptyWrapInner;
    let wrapEl = el.emptyWrapEl;
    let text = el.getAttribute('empty-text');
    let extraText = el.getAttribute('empty-extra-text');
    let img = emptyImg;
    switch (binding.value) {
      case 'collect':
        img = noCollect;
        break;
      case 'error':
        img = error;
        break;
      case 'm-collect':
        img = mcollect;
        break;
      case 'm-error':
        img = merror;
        break;
      case 'm-data':
        img = mdata;
        break;
      default:
        img = emptyImg;
        break;
    }
    if (binding.value) {
      wrapInner.innerHTML = `
        <div  class="ant-empty" style="text-align: center;">
          <div class="ant-empty-image">
            <img src=${img} alt="" />
          </div>
          ${
      // text ? `<p class="ant-empty-description">${text}${ extraText ? `` : ''}</p>` : ''
      text ? `<p class="ant-empty-description">${text}${extraText ? extraText : ''}</p>` : ''}
        </div>
      `;
      wrapEl.style.display = 'block';
    } else {
      wrapInner.innerHTML = '';
      wrapEl.style.display = 'none';
    }
  });
};
const directive = {
  bind(el, binding) {
    if (!el.style.position) {
      el.style.position = 'relative';
    }
    let wrapEl = document.createElement('div');
    wrapEl.style.position = 'absolute';
    wrapEl.style.left = '0';
    wrapEl.style.top = '0';
    wrapEl.style.width = '100%';
    wrapEl.style.height = '100%';
    wrapEl.style.pointerEvents = 'none';
    // wrapEl.style.background = 'rgba(255,255,255,0.3)'
    el.emptyWrapEl = wrapEl;
    let wrapInner = document.createElement('div');
    wrapInner.style.position = 'absolute';
    wrapInner.style.left = '50%';
    wrapInner.style.top = '50%';
    wrapInner.style.transform = 'translate(-50%,-50%)';
    wrapEl.appendChild(wrapInner);
    el.emptyWrapInner = wrapInner;
    el.appendChild(wrapEl);
    toggle(el, binding);
  },
  update(el, binding) {
    toggle(el, binding);
  },
  unbind(el) {
    el.emptyWrapEl && el.removeChild(el.emptyWrapEl);
  }
};
export default directive;